export { DeviceApi } from './DeviceApi';
